/**
 * Dev Mail - Inbox Command
 * Show recent messages for an email address
 */
import { Command } from 'commander';
import chalk from 'chalk';
import { ConfigService } from '../../../services/config.service.js';
import { TempMailApiService } from '../../../services/temp-mail.service.js';

interface InboxOptions {
    number: string;
    json?: boolean;
}

async function handleInbox(address: string, options: InboxOptions): Promise<void> {
    const config = await new ConfigService().load();
    if (!config) {
        console.error('❌ Not initialized. Run "jai1 auth" first.');
        process.exit(1);
    }

    const limit = Math.max(1, Math.min(30, parseInt(options.number, 10) || 1));
    const api = new TempMailApiService(config);
    const result = await api.getInbox(address, limit);

    if (!result.success) {
        if (options.json) {
            console.log(JSON.stringify({ success: false, error: result.error }));
        } else {
            console.error(`❌ ${result.error}`);
        }
        process.exit(1);
    }

    const messages = result.data ?? [];

    if (options.json) {
        console.log(JSON.stringify({ success: true, data: messages }));
        return;
    }

    if (!messages.length) {
        console.log(chalk.dim(`Inbox trống: ${address}`));
        return;
    }

    console.log(chalk.bold.cyan(`📥 Inbox: ${address}\n`));
    console.log(
        chalk.bold(`  ${'From'.padEnd(30)} ${'Subject'.padEnd(35)} Date`)
    );
    console.log('  ' + '─'.repeat(85));

    messages.forEach((msg) => {
        const from = (msg.from.name || msg.from.address).slice(0, 28).padEnd(30);
        const subject = (msg.subject || '(no subject)').slice(0, 33).padEnd(35);
        const date = new Date(msg.createdAt).toLocaleString('vi-VN');
        const seenDot = msg.seen ? ' ' : chalk.blue('●');
        console.log(`  ${seenDot} ${chalk.cyan(from)} ${subject} ${chalk.dim(date)}`);
        console.log(chalk.dim(`       ID: ${msg.id}`));
    });

    console.log();
    console.log(chalk.dim(`  Run \`j dev mail read ${address} <id>\` to read full email`));
}

export function createMailInboxCommand(): Command {
    return new Command('inbox')
        .description('Xem inbox của một email address')
        .argument('<address>', 'Địa chỉ email')
        .option('-n, --number <count>', 'Số lượng email cần lấy (mặc định: 1)', '1')
        .option('-j, --json', 'Output dạng JSON')
        .addHelpText('after', `
Examples:
  $ j dev mail inbox user@dollicons.com
  $ j dev mail inbox user@dollicons.com -n 5
  $ j dev mail inbox user@dollicons.com -j
`)
        .action(async (address: string, options: InboxOptions) => {
            await handleInbox(address, options);
        });
}
